import { create } from "../../../../../common/utils/zustand_state_manager";
import { InitializePaginationProperties, InitializeSetPaginationProperties, PaginationProperties, SetPaginationProperties } from "../../../../../common/utils/pagination_property";

/**
 * useChecklistMaquinaEquipItensCadastroPagination
 */

type State = PaginationProperties;

type Actions = SetPaginationProperties;

export const useChecklistMaquinaEquipItensCadastroPagination = create<State & Actions>((set) => ({
  ...InitializePaginationProperties(),
  ...InitializeSetPaginationProperties(set),
}));